<template>
  <div class="footer">
  	<div class="wrap">
      <div class="left">
        <div class="top"><div><div class="hl">Dennis Pacewicz</div> &copy; {{year}}</div></div>
          <div class="cols">
            <div class="col">
              <!-- <div>37 diary entries, 12 projects indexed</div> -->
              <div><a href="http://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank">BY-NC-SA 4.0</a> - <a href="https://github.com/lyninx">GitHub</a></div>
            </div>
          </div>
        </div>
      <div v-on:click="toggle_darkmode()">
        <img class="darkmode-indicator" v-bind:class="{ active: darkmode }" src="../../assets/icon.home.svg">
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      msg: ""
    }
  },
  computed: {
    year: () => {
      return new Date().getFullYear()
    },
    darkmode() {
      return this.$store.state.darkmode
    }
  },
  methods: {
    toggle_darkmode: function() {
      this.$store.dispatch('toggleDarkMode')
    }
  }
}
</script>